"use client"

import { Sparkles, X, LogIn, Lock } from "lucide-react"
import { useAnimatedClose } from "@/lib/use-animated-close"

export function LoginRequiredModal({
  onClose,
  onGoToLogin,
}: {
  onClose: () => void
  onGoToLogin: () => void
}) {
  const { closing, requestClose } = useAnimatedClose(onClose)
  return (
    <>
      {/* Backdrop */}
      <div
        className={`liquid-glass-overlay fixed inset-0 z-[60] transition-opacity duration-200 ${closing ? "opacity-0" : "animate-in fade-in duration-200"}`}
        onClick={requestClose}
        aria-hidden
      />

      {/* Modal */}
      <div className={`fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[60] w-full max-w-sm transition-all duration-200 ${closing ? "opacity-0 scale-95" : "animate-in fade-in zoom-in-95 duration-200"}`}>
        <div className="liquid-glass-panel rounded-2xl overflow-hidden">
          {/* Header decoration */}
          <div className="h-24 bg-gradient-to-br from-primary/20 via-primary/10 to-transparent relative overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full scale-150" />
                <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-primary shadow-lg shadow-primary/30">
                  <Lock className="h-6 w-6 text-primary-foreground" />
                </div>
              </div>
            </div>
            {/* Close button */}
            <button
              onClick={requestClose}
              className="absolute top-3 right-3 flex h-8 w-8 items-center justify-center rounded-lg hover:bg-background/50 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          {/* Content */}
          <div className="px-6 pb-6 pt-4 text-center">
            <h2 className="text-lg font-semibold text-foreground mb-2">
              需要登录
            </h2>
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              安装技能需要先登录你的账户。登录后即可解锁所有技能的安装和使用。
            </p>

            {/* Actions */}
            <div className="flex flex-col gap-2">
              <button
                onClick={() => {
                  requestClose()
                  onGoToLogin()
                }}
                className="w-full h-10 flex items-center justify-center gap-2 rounded-xl bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
              >
                <LogIn className="h-4 w-4" />
                前往登录
              </button>
              <button
                onClick={requestClose}
                className="w-full h-10 flex items-center justify-center gap-2 rounded-xl border border-border bg-secondary/40 text-foreground text-sm font-medium hover:bg-secondary transition-colors"
              >
                继续浏览
              </button>
            </div>

            {/* Hint */}
            <p className="text-caption text-muted-foreground mt-4">
              还没有账户? 登录页面可申请内测资格
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
